import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ReportAttachments from "./Components/ReportAttachments";

const ViewReport = () => {
  const { attachmentKey } = useParams();

  const [iframeLoading, setIframeLoading] = useState(false);
  const [reportPdfUrl, setReportPdfUrl] = useState("");

  const [getFileUrl, { isLoading, isError, isFetching }] = useLazyGetFileUrlQuery(attachmentKey);

  /**
   * To-Do: replace static attachments & resources with dynamic API
   */
  const resources = [{
    attachment_key: "intakereport_1737121458959.pdf",
    attachment_name: "Classroom Plan",
  }];

  const attachments = [{
    attachment_key: "intakereport_1737121458959.pdf",
    attachment_name: "Classroom Plan",
  }];

  useEffect(() => {
    if (!attachmentKey) {
      return;
    }

    async function getReportUrl() {
      try {
        let response = await getFileUrl(attachmentKey).unwrap();
        setReportPdfUrl(response);
      } catch (err) {
        console.error("Error loading report", err);
      }
    }

    getReportUrl();
  }, [attachmentKey]);

  const handleViewPdf = async (name) => {

    try {
      const url = await getFileUrl(name).unwrap();
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };

  return (
    <section className="report-outer py-3 position-relative">
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
              <div className="left">
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                  <li className="">
                    <Link
                      className="themeBlue fw-sbold"
                      style={{ textDecoration: "underline" }}
                      to={-1}
                    >
                      <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>
                      Back
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col lg="12">
            {isLoading || iframeLoading ? (
              <LoadingIndicator />
            ) : isError ? (
              <ErrorComponent />
            ) : reportPdfUrl && (
              <>
                {isFetching && (
                  <LoadingOverlay />
                )}
                {/* <Row>
                  <Col lg="6">
                    <ReportAttachments
                      attachments={attachments}
                      handleViewPdf={handleViewPdf}
                      title={"Attachments:"}
                    />
                  </Col>
                  <Col lg="6">
                    <ReportAttachments
                      attachments={resources}
                      handleViewPdf={handleViewPdf}
                      title={"Resources:"}
                    />
                  </Col>
                </Row> */}
                <iframe
                  onLoad={() => console.log("Loading", typeof setIframeLoading)}
                  src={`${reportPdfUrl}#toolbar=1&navpanes=0`}
                  showToolbar={false}
                  style={{
                    width: "100%",
                    height: "90vh"
                  }}
                />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}


export default ViewReport;